import React, { FC } from 'react';

import LegalPage from '~/projects/polyllm-chat/components/LegalPage';
import LegalLoading from '~/projects/polyllm-chat/components/LegalPage/components/LegalLoading';
import { subscriptionTermsMarkdown } from '~/projects/polyllm-chat/components/LegalPage/config/content';
import { subscriptionTermsMarkdownUs } from '~/projects/polyllm-chat/components/LegalPage/config/contentUs';
import { legalMarkdownVariables } from '~/projects/polyllm-chat/components/LegalPage/config/variables';
import useLegalMarkdownByCountry from '~/projects/polyllm-chat/components/LegalPage/hooks/useLegalMarkdownByCountry';

const SubscriptionTermsPage: FC = () => {
  const { markdown, ready } = useLegalMarkdownByCountry({
    default: subscriptionTermsMarkdown,
    US: subscriptionTermsMarkdownUs,
  });

  if (!ready) {
    return <LegalLoading />;
  }

  return <LegalPage markdown={markdown} variables={legalMarkdownVariables} />;
};

export default SubscriptionTermsPage;
